import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import axios from "axios";
import Bridge from "@/components/dsbridge.js";
import MD5 from "crypto-js/md5";
import { getDeviceId } from "@/utils/deviceId";
import { getOperatingSystem } from "@/utils/platform";
// import VuCountryIntl from 'vue-country-tel';
// import 'vue-country-tel/lib/vue-country-intl.css'

Vue.prototype.$dsbridge = Bridge;
// Vue.component(VuCountryIntl.name, VuCountryIntl);
// Vue.prototype.$url = "https://api-test.528btc.com.cn"; //本地测试地址
Vue.prototype.$url = "https://api.shlwsj.asia"; //生产地址
Vue.config.productionTip = false;
Vue.prototype.$axios = axios.create({
  // 去掉域名前缀
  baseURL: "https://api.shlwsj.asia",
  // baseURL: "https://api-test.528btc.com.cn",
  // 其他配置...
});
// Vue.prototype.$token = localStorage.getItem("token");

function httpHeaderParams() {
  // 拿当前时间戳
  const timestamp = Date.now();
  // 后端提供 随时会改
  const apiSecret = "jFhDhQZCdP";
  // 获取时间戳前6位
  const timestampPrefix = timestamp.toString().substring(0, 6);
  // 拼接字符串: 时间戳 + 加密字符串 + 时间戳前6位
  const stringToSign = `${timestamp}${apiSecret}${timestampPrefix}`;
  //生成MD5 转大写
  const sign = MD5(stringToSign);
  const headers = {
    sign: sign,
    timestamp: timestamp,
    source: getOperatingSystem(),
    Authorization: localStorage.getItem("token"),
    deviceId: getDeviceId(),
  };
  return headers;
}
Vue.prototype.$operatingSystem = getOperatingSystem();

Vue.prototype.$axios.interceptors.request.use(
  function (config) {
    const customHeaders = httpHeaderParams();
    Object.assign(config.headers, customHeaders);
    // 在发送请求之前做些什么
    // config.headers.Authorization = '+PQddp7K9/npTSwpE4/SqAkCWS05dWdFloeDxbLrIKPwkZfLl7iHdkeV2cfrbW8s2lMyNrKXQ8McWnATSbXnWRyLbK8D5BsFWOWoM9qhibckYj5P9oSfFRkoTq27pAdO'
    config.headers.source = getOperatingSystem();
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    console.log(error);
    // config.headers.Authorization = localStorage.getItem("token")
    // return Promise.reject(error);
  }
);

new Vue({
  router,
  store,
  render: function (h) {
    return h(App);
  },
}).$mount("#app");
